import { CountryCodeEnum } from './CountryCodeEnum';
import Countries from './Countries.json';
import RequestImageDim from './RequestImageDim';
import RequestImagePreview from './RequestImagePreview';
import { HttpStatusCodeEnum } from './HttpStatusCodeEnum';

export { RequestImageDim, RequestImagePreview, HttpStatusCodeEnum };

export enum RequestTypeEnum {
  SingleSelect = 's_selection',
  MultiSelect = 'm_selection',
  Free = 'free',
}

export interface IDateTimeRange {
  start: string | null;
  end: string | null;
}
type FileType = 'pdf' | 'doc' | 'file';
export interface IFilenameUrl {
  id?: number;
  type?: FileType;
  blob?: File;
  filename: string;
  url: string;
}

export interface IRequestQuestion {
  text: string;
  imageList: IFilenameUrl[];
  fileList: IFilenameUrl[];
  from: string;
  createdDate: string;
}

export interface IRequestReplySelectItem {
  id: number;
  text: string;
  selected: boolean;
}

export interface IRequestReplyFile {
  text: string;
  imageList: IFilenameUrl[];
  fileList: IFilenameUrl[];
  from: string;
  createdDate: string;
}

export interface IRequestReplySelect {
  list: IRequestReplySelectItem[];
  other: string | null;
  from: string;
  createdDate: string;
}

export interface IRequestSelectionOption {
  selectionList: IRequestReplySelectItem[];
  useOther: boolean;
}

export interface IRequest {
  qnaId: number;
  completed: boolean;
  type: RequestTypeEnum;
  deadline: string;
  countryList: CountryCodeEnum[];
  question: IRequestQuestion;
  selectionOption: IRequestSelectionOption | null;
  answer: IRequestReplySelect | IRequestReplyFile | null;
  maxFileNumber?: number | null;
  createdDate?: string;
  requestOwner?: string;
}

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

/***
 @description Intl 국제 표준 ISO 코드 검증
 @param code {string} 2two-letter country code
 @returns {boolean}
 **/
const isValidCountryCode = (code: string) => {
  try {
    // 유효하면 “South Korea”, “Japan” 같은 이름이 반환됨
    const name = regionNames.of(code.toUpperCase());
    return !!name && name !== code.toUpperCase();
  } catch {
    return false;
  }
};

// todo-@elie: 해당 함수 shared root로 이동 + icon 폴리필 적용 https://github.com/marqvision/marqvision-web/pull/410#discussion_r2062814098
export const getFlagEmoji = (countryCode?: string): string => {
  if (!countryCode) return '';

  if (!isValidCountryCode(countryCode)) return String.fromCodePoint(parseInt('1F30E', 16));

  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0));

  return String.fromCodePoint(...codePoints);
};

export const getCountry = (countryCode: string) => {
  const obj = Countries.find(({ code }) => code === countryCode);

  return obj;
};

export const CountryCode = Countries;
export * from './CountryCodeEnum';
export * from './HttpStatusCodeEnum';
export * from './RequestImageDim';
export * from './RequestImagePreview';
export * from './timeZone';
